import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Divider, Item } from 'semantic-ui-react';
import StyledGroupList from './GroupList.style';

const GroupList = ({ list, title }) => {
  if (!list) {
    return null;
  }

  return (
    <Fragment>
      <StyledGroupList className="grouplist">
        {title && <Item.Meta>{title}</Item.Meta>}
        {list && list.length > 0 && (
          <Item.Group data-testid="group-list-group">
            {list.map((item, idx) => (
              <Item
                key={`${title}${idx}`}
                data-testid={`group-list-item-${idx}`}
              >
                <Item.Header>{item.header}</Item.Header>
                <Item.Description>
                  <Link to={item.url}>{item.label}</Link>
                </Item.Description>
              </Item>
            ))}
          </Item.Group>
        )}
      </StyledGroupList>
      <Divider />
    </Fragment>
  );
};

GroupList.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      url: PropTypes.string,
      label: PropTypes.string
    })
  )
};
export default GroupList;



// WEBPACK FOOTER //
// ./src/components/GroupList/GroupList.js